import { layout } from '../../App.routing'

export const entertaimentAndLifestyleSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        stretchColumns: true,
        verticalSpacing: 'lg',
        hasBorder: true,
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'lifestyle',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Lifestyle',
                        headingUrl: '/lifestyle',
                        section: 'lifestyle',
                    },
                    verticalSpacing: 'xs',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    hasBorder: false,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'entertainment',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Entertainment',
                        headingUrl: '/entertainment',
                        section: 'entertainment',
                    },
                    verticalSpacing: 'xs',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    hasBorder: false,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
    },
})
